/** 与项目编辑页一致：接口可能返回对象或 JSON 字符串 */
export function parseProjectAiReviewSettings(raw) {
    if (raw == null || raw === '') {
        return null;
    }
    let parsed = raw;
    if (typeof raw === 'string') {
        const t = raw.trim();
        if (t === '' || t === 'null') {
            return null;
        }
        try {
            parsed = JSON.parse(raw);
        } catch {
            return null;
        }
    }
    return parsed;
}

export function isProjectAiReviewEnabled(project) {
    if (project == null) {
        return false;
    }
    const ar = parseProjectAiReviewSettings(project.aiReviewSettings);
    if (ar == null) {
        return false;
    }
    return ar.enabled === true || ar.enabled === 1;
}

/** AI 初审理由字段顺序（与接口约定一致，用于展示与拼信） */
export const AI_REVIEW_MSG_KEYS = ['page_num', 'template', 'duplicate'];

/**
 * 从案例 ai_review_msg 解析为各字段文案（无则空串）
 * @param {unknown} raw JSON 字符串或已解析对象
 * @returns {{ page_num: string, template: string, duplicate: string }}
 */
export function parseAiReviewMessageParts(raw) {
    const empty = { page_num: '', template: '', duplicate: '' };
    if (raw == null || raw === '') {
        return { ...empty };
    }
    let obj = raw;
    if (typeof raw === 'string') {
        const t = raw.trim();
        if (t === '' || t === 'null') {
            return { ...empty };
        }
        try {
            obj = JSON.parse(raw);
        } catch {
            return { ...empty };
        }
    }
    if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) {
        return { ...empty };
    }
    const out = { ...empty };
    for (const k of AI_REVIEW_MSG_KEYS) {
        const v = obj[k];
        out[k] = v != null && String(v).trim() !== '' ? String(v).trim() : '';
    }
    return out;
}

/** 含至少一条非空理由时返回 true */
export function hasAiReviewMessageContent(raw) {
    const p = parseAiReviewMessageParts(raw);
    return AI_REVIEW_MSG_KEYS.some(k => p[k]);
}

/**
 * 从案例 ai_review_msg 解析 AI 驳回理由，按 page_num / template / duplicate 非空项拼接
 */
export function formatAiReviewRejectReasons(raw) {
    const parts = parseAiReviewMessageParts(raw);
    return AI_REVIEW_MSG_KEYS.map(k => parts[k])
        .filter(Boolean)
        .join('；');
}
